import React from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { Route, Switch } from 'react-router-dom';
import { AuthLayout, MainLayout } from './components/layout/index';
import { PageLoading } from './components/page/index';
import pJson from '../package.json';

// eslint-disable-next-line no-console
console.info(
  `%c Current Version: ${pJson.version}`,
  'background: #222; color: #bada55'
);

const App = () => (
  <div className="App">
    <Switch>
      <Route path="/auth" component={AuthLayout} />
      <Route path="/" component={MainLayout} />
    </Switch>
    <PageLoading spinConfig={{ size: 'large' }} />
  </div>
);

export default DragDropContext(HTML5Backend)(App);



// WEBPACK FOOTER //
// ./src/App.js